import Analytics from './Analytics'
import AnalyticsHeader from './AnalyticsHeader'
import AnalyticsHelp from './AnalyticsHelp'

export default {
  default: Analytics,
  header: AnalyticsHeader,
  help: AnalyticsHelp,
}
